export enum RaceStatus {
  INACTIVE = 0,
  REGISTRATION_OPEN = 1,
  REGISTRATION_CLOSED = 2,
  FINISHED = 3,
  HIDDEN = 4,
  DELETED = 8
}
